import { render, staticRenderFns } from "./blogger_set.vue?vue&type=template&id=7516577b&scoped=true"
import script from "./blogger_set.vue?vue&type=script&lang=ts"
export * from "./blogger_set.vue?vue&type=script&lang=ts"
import style0 from "./blogger_set.vue?vue&type=style&index=0&id=7516577b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7516577b",
  null
  
)

export default component.exports